import { RegisterItem } from '../decorators/snitem-factory-decorator';
import { CNDocument } from '../models/cndocument';
import { CNAnonymousReportRequest } from './cnanonymousreportrequest';

@RegisterItem()
export class CNDocumentFile extends CNDocument {

    private documentType: string;

    public requests: CNAnonymousReportRequest[] = [];
    
    constructor(itemid: number = 0) {
        super(itemid);
        this.key = 'SNItem.SNDocument.CNDocument.CNDocumentFile';
    }

    get type(): string {
        if (!this.documentType && this.getProperty('type')) {
            try {
                this.documentType = this.getProperty('type').split('/').pop().toLowerCase();
            } catch {
                this.documentType = 'none';
            }
        }
        return this.documentType;
    }

    get filename(): string {
        return this.getProperty('original_filename');
    }

    get requestRead(): boolean {
        if (!this.requests || this.requests.length === 0) {
            return false;
        }
        let foundRequestRead = false;
        this.requests.forEach(request => {
            if (request.getProperty('ReadStatus') === 'Read') {
                foundRequestRead = true;
            }
        });
        return foundRequestRead;
    }

    public clone(): any {
        return new CNDocumentFile();
    }
}

